export default __webpack_public_path__ + "static/media/undraw_privacy_protection_nlwy@2x.46370f10.png";